import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { ToastContainer, toast } from "react-toastify";

const SelfAppraisalScore = () => {
  const { summaryId } = useParams();
  const history = useHistory();

  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/self-appraisal/score/${summaryId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((res) => setData(res.data))
      .catch(() => toast.error("Failed to load score"));
  }, [summaryId]);

  if (!data) return <div className="card p-4">Loading...</div>;

  const { employee, evaluator, questions } = data;

  return (
    <div className="card">
      <ToastContainer />

      {/* HEADER */}
      <div className="card-header d-flex justify-content-between">
        <h5>Self Appraisal Score</h5>
        <button
          className="btn btn-primary"
          onClick={() => history.push("/OthersAppraisalList")}
        >
          Back
        </button>
      </div>

      {/* BASIC INFO */}
      <div className="card-body bg-light">
        <div className="row">
          <div className="col-md-4">
            <b>Employee</b>
            <p>
              {employee.employee_id} - {employee.first_name}{" "}
              {employee.last_name}
            </p>
            <p>{employee.designation_name}</p>
            <p>{employee.department_name}</p>
          </div>

          <div className="col-md-4">
            <b>Evaluator</b>
            <p>
              {evaluator.employee_id} - {evaluator.first_name}{" "}
              {evaluator.last_name}
            </p>
            <p>{evaluator.designation_name}</p>
            <p>{evaluator.department_name}</p>
          </div>

          <div className="col-md-4">
            <b>Total Score</b>
            <h3 className="text-danger">{employee.total_score}</h3>
            <p>Evaluated on: {employee.entry_date}</p>
          </div>
        </div>
      </div>

      {/* QUESTION WISE ANSWERS */}
      <div className="card-body">
        {questions.map((q, i) => (
          <div key={q.question_id} className="mb-4">
            <h6 style={{ color: "#ea4e1b" }}>
              {i + 1}. {q.question_title}
            </h6>

            {q.options.map((op) => (
              <p
                key={op.value_id}
                style={{
                  marginLeft: 20,
                  color:
                    q.option_id === op.value_id ? "#25ce3f" : "#000",
                  fontWeight:
                    q.option_id === op.value_id ? "bold" : "normal",
                }}
              >
                {op.value_title}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelfAppraisalScore;
